<template>
  <div :class="$style.waterfall+' clearfix'">
    <div :class="$style.items">
      <a href="javascript:void(0)" v-for="item in list1" :key="item.id" class="aContain" v-show="!hideState[item.id]" @click.stop="jumpUrl(item.gpUrl,item.id)">
        {{hideState[item.id]}}
        <div :class="$style.cellItem">
          <div :class="$style.lbsWrap" v-show="showState[item.id]">
            <span :class="$style.icoLbs">{{item.distinct}}km</span>
            <span style="margin:0 6px;">|</span>
            <span>{{item.city}}</span>
          </div>
          <div :class="$style.actionWrap" v-show="showState[item.id]">
            <span :class="$style.icoView">{{item.view}}k</span>
            <span :class="$style.icoHeart">{{renderHeart(item.view)}}k</span>
          </div>
          <div :class="$style.icoPlay" v-show="showState[item.id]"></div>
          <img v-if="item.url" :src="item.url" alt="加载错误" @load="show(item.id)" @click="split()" />
        </div>
      </a>
    </div>
    <div :class="$style.items">
      <a href="javascript:void(0)" v-for="item in list2" :key="item.id" class="aContain" v-show="!hideState[item.id]" @click.stop="jumpUrl(item.gpUrl,item.id)">
        <div :class="$style.cellItem">
          <div :class="$style.lbsWrap" v-show="showState[item.id]">
            <span :class="$style.icoLbs">{{item.distinct}}km</span>
            <span style="margin:0 6px;">|</span>
            <span>{{item.city}}</span>
          </div>
          <div :class="$style.actionWrap" v-show="showState[item.id]">
            <span :class="$style.icoView">{{item.view}}k</span>
            <span :class="$style.icoHeart">{{renderHeart(item.view)}}k</span>
          </div>
          <div :class="$style.icoPlay" v-show="showState[item.id]"></div>
          <img v-if="item.url" :src="item.url" alt="加载错误" @load="show(item.id)" @error="hide(item.id)" />
        </div>
      </a>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { randomArea, randomKM, randomNum, randomView } from "../util";

export default {
  data () {
    this.flag = false
    return {
      list1: [],
      list2: [],
      kmList: [],
      isMore: true,
      page: 1,
      showState: {},
      hideState: {}
    };
  },
  components: {
  },
  computed: mapState({
    waterfalllist: state => {
      if (state.count == state.list.length && state.list.length != 0) {
        console.log("this", this);
        this.isMore && (this.isMore = false);
        return;
      }
      state.list.forEach((el) => {
        el.km = randomKM();
        el.area = randomArea();
        el.view = randomView();
      });

      return state.list;
    }
  }),
  watch: {
    waterfalllist: function (newVal, oldVal) {
      if (newVal != oldVal) {
        this.list1 = [];
        this.list2 = [];
        newVal.forEach((el, index) => {
          if ((index + 1) % 2 == 1) {
            this.list1.push(el)
          } else {
            this.list2.push(el)
          }
        })
      }
    }
  },
  mounted () {
    this.$store.dispatch("getList", 1);
  },
  methods: {
    getMore () {
      if (!this.isMore) return;
      ++this.page;
      this.$store.dispatch("getList", this.page);
    },
    renderHeart (num) {
      return ((num * randomNum(6, 15)) / 100).toFixed(1);
    },
    isShow (id) {
      return this.showState[id]
    },
    split () {
    },
    show (id) {
      console.log(id + ' loaded')
      let temp = Object.assign({}, this.showState)
      temp[id] = true
      this.showState = temp
      if (id > 6) {
        if (!this.flag) {
          this.$store.dispatch('showBottomButton', true)
          this.flag = true
        }
      }
    },
    hide (id) {
      let temp = Object.assign({}, this.hideState)
      temp[id] = true
      this.hideState = temp
    },
    jumpUrl (url, id) {
      if (this.$store.state.split === '1') {
        location.href = 'http://rec.4funvideo.com/activity/4fun.apk'
        return;
      }
      this.$store.dispatch("report")
      window._czc.push(['_trackEvent', 'waterfall', id]);
      setTimeout(() => {
        location.href = url
      }, 300);
      setTimeout(() => {
        this.$store.dispatch('setPage', 2)
      }, 50);
    }
  }
};
</script>

<style module lang="scss">
.waterfall {
  width: 100vw;
  // height: 100vh;
  columns: 2;
  position: relative;
  // overflow-y: auto;
  margin-bottom: 10px;
  display: flex;
  justify-content: space-around;
  .items {
    width: 368px;
  }
  .cellItem {
    position: relative;
    img {
      width: 100%;
      border-radius: 5px;
    }
    padding: 4px 2px;

    .lbsWrap {
      padding: 0 4px;
      height: 20px;
      background-color: rgba(0, 0, 0, 0.7);
      position: absolute;
      bottom: 34px;
      left: 10px;
      z-index: 2;
      color: #fff;
      font-size: 12px;
      display: flex;
      align-items: center;

      .icoLbs {
        background: url("../assets/imgs/ico-lbs.svg") left center no-repeat;
        background-size: 12px 12px;
        height: 12px;
        display: inline-block;
        padding-left: 16px;
        line-height: 1.1;
        display: inline-block;
      }
    }
    .actionWrap {
      position: absolute;
      bottom: 10px;
      left: 10px;
      display: flex;
      align-items: center;
      z-index: 2;
      color: #fff;
    }
    .icoView {
      background: url("../assets/imgs/ico-view.png") left center no-repeat;
      background-size: contain;
      height: 14px;
      display: inline-block;
      margin-right: 20px;
      padding-left: 20px;
      color: #fff;
    }
    .icoHeart {
      background: url("../assets/imgs/ico-heart.png") left center no-repeat;
      background-size: contain;
      height: 14px;
      display: inline-block;
      margin-right: 20px;
      padding-left: 16px;
      color: #fff;
    }
    .icoPlay {
      background: url("../assets/imgs/ico-play.svg") left center no-repeat;
      background-size: 36px 36px;
      width: 36px;
      height: 36px;
      display: inline-block;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      position: absolute;
      z-index: 2;
    }
  }
}
</style>
<style>
.slot-box {
  left: 200% !important;
}
</style>
<style>
.aContain {
  /* float:left; */
}
</style>
